const config = {
  baseURL: process.env.VUE_APP_PUBLIC_URL || `http://localhost:8080`,
  strapiURL: process.env.VUE_APP_STRAPI_URL || `http://localhost:1337`,
  strapiToken: process.env.VUE_APP_STRAPI_TOKEN,
};

export default config;
